import { ArrowRight, Server, Sprout } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Section, SectionHead } from "./Reveal";

export const Audiences = () => {
  const { t } = useLang();
  const tracks = [
    { ...t.audi.a, icon: Server, testid: "audience-card-it-teams" },
    { ...t.audi.b, icon: Sprout, testid: "audience-card-native-business" },
  ];

  return (
    <Section id="para-quem">
      <SectionHead label={t.audi.label} title={t.audi.heading} />
      <div className="grid gap-6 md:grid-cols-2">
        {tracks.map((a, i) => {
          const Icon = a.icon;
          const accent = i === 0 ? "text-volt" : "text-acid";
          const hover = i === 0 ? "hover:border-volt/40" : "hover:border-acid/40";
          return (
            <Reveal key={a.testid} delay={i * 0.1} className="h-full">
              <div
                data-testid={a.testid}
                className={`group relative h-full overflow-hidden rounded-2xl border border-line bg-ink-900/60 p-8 transition-all duration-300 hover:-translate-y-1 md:p-10 ${hover}`}
              >
                <span className="pointer-events-none absolute -right-2 -top-6 font-display text-8xl font-black text-white/5">
                  0{i + 1}
                </span>
                <Icon size={22} className={accent} />
                <p className={`mt-6 font-mono text-[11px] uppercase tracking-[0.25em] ${accent}`}>
                  {a.tag}
                </p>
                <h3 className="mt-4 max-w-sm font-display text-2xl font-bold tracking-tight md:text-3xl">
                  {a.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-mist md:text-base">{a.desc}</p>
                <ul className="mt-8 space-y-3.5">
                  {a.bullets.map((b) => (
                    <li key={b} className="flex gap-3 text-sm text-white/85">
                      <ArrowRight size={16} className={`mt-0.5 shrink-0 ${accent}`} />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
